<mat-card class="confirmation-dialog">
  <!-- Header -->
  <mat-card-header class="dialog-header">
    <mat-card-title>{{ data.title }}</mat-card-title>
    <button mat-icon-button (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <!-- Content -->
  <mat-card-content class="dialog-content">
    <div class="message">
      <mat-icon class="warning-icon">warning</mat-icon>
      <p>{{ data.message }}</p>
    </div>
  </mat-card-content>

  <!-- Actions -->
  <mat-card-actions class="dialog-actions">
    <button mat-button class="cancel-btn" (click)="cancel()">
      {{ data.cancelText }}
    </button>
    <button
      mat-flat-button
      [color]="data.confirmColor"
      (click)="confirm()"
    >
      {{ data.confirmText }}
    </button>
  </mat-card-actions>
</mat-card>
